import http from '@/requests/http'

class ApiKey {
  static findAll (params) {
    return http.post('management/api-key', params)
  }
  static getKey () {
    return http.post('management/api-key/get-key')
  }
  static store (params) {
    return http.post('management/api-key/store', params)
  }
  static view (params) {
    return http.post('management/api-key/view', params)
  }
  static update (params) {
    return http.post('management/api-key/update', params)
  }
  static destroy (params) {
    return http.post('management/api-key/destroy', params)
  }
}

export default ApiKey
